import { Button } from '@vkontakte/vkui';
import AlbumIcon from 'img/empty-state/album.png';
import AttachesIcon from 'img/empty-state/attaches.png';
import AlbumIconDark from 'img/empty-state/dark/album.png';
import AttachesIconDark from 'img/empty-state/dark/attaches.png';
import FavoritesIconDark from 'img/empty-state/dark/favorites.png';
import FeedAllIconDark from 'img/empty-state/dark/feed_all.png';
import FeedRestIconDark from 'img/empty-state/dark/feed_rest.png';
import GalleryAllIconDark from 'img/empty-state/dark/gallery_all.png';
import GalleryDesktopIconDark from 'img/empty-state/dark/gallery_desktop.png';
import GalleryMobileIconDark from 'img/empty-state/dark/gallery_mobile.png';
import SharedAutodeleteIconDark from 'img/empty-state/dark/shared_autodelete.png';
import SharedIncomingIconDark from 'img/empty-state/dark/shared_incoming.png';
import SharedLinkIconDark from 'img/empty-state/dark/shared_links.png';
import TrashIconDark from 'img/empty-state/dark/trash.png';
import VigboUnlinked from 'img/empty-state/empty_vigbo_unlinked.png';
import FavoritesIcon from 'img/empty-state/favorites.png';
import FeedAllIcon from 'img/empty-state/feed_all.png';
import FeedRestIcon from 'img/empty-state/feed_rest.png';
import GalleryAllIcon from 'img/empty-state/gallery_all.png';
import GalleryDesktopIcon from 'img/empty-state/gallery_desktop.png';
import GalleryMobileIcon from 'img/empty-state/gallery_mobile.png';
import SharedAutodeleteIcon from 'img/empty-state/shared_autodelete.png';
import SharedIncomingIcon from 'img/empty-state/shared_incoming.png';
import SharedLinkIcon from 'img/empty-state/shared_links.png';
import TrashIcon from 'img/empty-state/trash.png';
import AlbumIconB2b from 'img/empty-state-b2b/album.png';
import AttachesIconB2b from 'img/empty-state-b2b/attaches.png';
import AlbumIconB2bDark from 'img/empty-state-b2b/dark/album.png';
import AttachesIconB2bDark from 'img/empty-state-b2b/dark/attaches.png';
import EmptyB2BIconDark from 'img/empty-state-b2b/dark/empty.png';
import FavoritesIconB2bDark from 'img/empty-state-b2b/dark/favorites.png';
import FeedAllIconB2bDark from 'img/empty-state-b2b/dark/feed_all.png';
import FeedDocumentIconB2bDark from 'img/empty-state-b2b/dark/feed_document.png';
import FeedImageIconB2bDark from 'img/empty-state-b2b/dark/feed_image.png';
import FeedMusicIconB2bDark from 'img/empty-state-b2b/dark/feed_music.png';
import FeedVideoIconB2bDark from 'img/empty-state-b2b/dark/feed_video.png';
import GalleryAllIconB2bDark from 'img/empty-state-b2b/dark/gallery_all.png';
import SharedIncomingIconB2bDark from 'img/empty-state-b2b/dark/shared-incoming.png';
import SharedLinkIconB2bDark from 'img/empty-state-b2b/dark/shared-links.png';
import TrashIconB2bDark from 'img/empty-state-b2b/dark/trash.png';
import EmptyB2BIcon from 'img/empty-state-b2b/empty.png';
import FavoritesIconB2b from 'img/empty-state-b2b/favorites.png';
import FeedAllIconB2b from 'img/empty-state-b2b/feed_all.png';
import FeedDocumentIconB2b from 'img/empty-state-b2b/feed_document.png';
import FeedImageIconB2b from 'img/empty-state-b2b/feed_image.png';
import FeedMusicIconB2b from 'img/empty-state-b2b/feed_music.png';
import FeedVideoIconB2b from 'img/empty-state-b2b/feed_video.png';
import GalleryAllIconB2b from 'img/empty-state-b2b/gallery_all.png';
import SharedIncomingIconB2b from 'img/empty-state-b2b/shared-incoming.png';
import SharedLinkIconB2b from 'img/empty-state-b2b/shared-links.png';
import TrashIconB2b from 'img/empty-state-b2b/trash.png';
import React from 'react';
import { ANTIVIRUS_BRAND } from 'reactApp/appHelpers/featuresHelpers/features/antivirusBrand';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { FeedCategoryType } from 'reactApp/modules/feed/feed.types';
import { GalleryCategoryType } from 'reactApp/modules/gallery/gallery.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { VigboAccountLinkState } from 'reactApp/modules/vigbo/vigbo.types';
import { getQuotaPromoUrl } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';
import { onClickCreateNew } from 'reactApp/ui/Datalist/UserActions/onClickAction';
import { sendEmptyStatesAnalitics } from 'reactApp/utils/emptyStatesGa';

import { Albums } from './components/Albums';
import { SharedAutoDelete } from './components/SharedAutoDelete';
import { Vigbo } from './components/Vigbo';
import styles from './Empty.css';
import type { CategoryType, Config, EmptyComponentProps, IconConfig } from './Empty.types';

const getIcon = ({ b2bIcon, b2cIcon, b2bIconDark, b2cIconDark, isB2BUser }: IconConfig) => ({
    icon: isB2BUser ? b2bIcon : b2cIcon,
    iconDark: isB2BUser ? b2bIconDark : b2cIconDark,
});

const getIcons = ({ isB2BUser }: EmptyComponentProps) => {
    return {
        sharedLink: getIcon({
            b2cIcon: SharedLinkIcon,
            b2cIconDark: SharedLinkIconDark,
            b2bIcon: SharedLinkIconB2b,
            b2bIconDark: SharedLinkIconB2bDark,
            isB2BUser,
        }),
        sharedIncoming: getIcon({
            b2cIcon: SharedIncomingIcon,
            b2cIconDark: SharedIncomingIconDark,
            b2bIcon: SharedIncomingIconB2b,
            b2bIconDark: SharedIncomingIconB2bDark,
            isB2BUser,
        }),
        gallery: getIcon({
            b2cIcon: GalleryAllIcon,
            b2cIconDark: GalleryAllIconDark,
            b2bIcon: GalleryAllIconB2b,
            b2bIconDark: GalleryAllIconB2bDark,
            isB2BUser,
        }),
        favorites: getIcon({
            b2cIcon: FavoritesIcon,
            b2cIconDark: FavoritesIconDark,
            b2bIcon: FavoritesIconB2b,
            b2bIconDark: FavoritesIconB2bDark,
            isB2BUser,
        }),
        feedAll: getIcon({
            b2cIcon: FeedAllIcon,
            b2cIconDark: FeedAllIconDark,
            b2bIcon: FeedAllIconB2b,
            b2bIconDark: FeedAllIconB2bDark,
            isB2BUser,
        }),
        feedDocument: getIcon({
            b2cIcon: FeedRestIcon,
            b2cIconDark: FeedRestIconDark,
            b2bIcon: FeedDocumentIconB2b,
            b2bIconDark: FeedDocumentIconB2bDark,
            isB2BUser,
        }),
        feedImage: getIcon({
            b2cIcon: FeedRestIcon,
            b2cIconDark: FeedRestIconDark,
            b2bIcon: FeedImageIconB2b,
            b2bIconDark: FeedImageIconB2bDark,
            isB2BUser,
        }),
        feedMusic: getIcon({
            b2cIcon: FeedRestIcon,
            b2cIconDark: FeedRestIconDark,
            b2bIcon: FeedMusicIconB2b,
            b2bIconDark: FeedMusicIconB2bDark,
            isB2BUser,
        }),
        feedVideo: getIcon({
            b2cIcon: FeedRestIcon,
            b2cIconDark: FeedRestIconDark,
            b2bIcon: FeedVideoIconB2b,
            b2bIconDark: FeedVideoIconB2bDark,
            isB2BUser,
        }),
        attaches: getIcon({
            b2cIcon: AttachesIcon,
            b2cIconDark: AttachesIconDark,
            b2bIcon: AttachesIconB2b,
            b2bIconDark: AttachesIconB2bDark,
            isB2BUser,
        }),
        trashbin: getIcon({
            b2cIcon: TrashIcon,
            b2cIconDark: TrashIconDark,
            b2bIcon: TrashIconB2b,
            b2bIconDark: TrashIconB2bDark,
            isB2BUser,
        }),
        album: getIcon({ b2cIcon: AlbumIcon, b2cIconDark: AlbumIconDark, b2bIcon: AlbumIconB2b, b2bIconDark: AlbumIconB2bDark, isB2BUser }),
        incomingPublic: getIcon({
            b2cIcon: SharedIncomingIcon,
            b2cIconDark: SharedIncomingIconDark,
            b2bIcon: SharedIncomingIconB2b,
            b2bIconDark: SharedIncomingIconB2bDark,
            isB2BUser,
        }),
    };
};

const sharedIncomingText = `Когда с вами поделятся ссылкой, файлы будут\nздесь — проверены антивирусом${
    ANTIVIRUS_BRAND === 'default' ? '' : ` ${ANTIVIRUS_BRAND}`
}.\n`;

const getConfigByStorage = (props: EmptyComponentProps) => {
    const { isB2BUser } = props;
    const icons = getIcons(props);

    return new Map<EStorageType, Config | Map<CategoryType | undefined, Config>>()
        .set(EStorageType.sharedLinks, {
            ...icons.sharedLink,
            title: isB2BUser ? 'Делитесь' : 'Вы пока ничем\nне поделились',
            description: isB2BUser
                ? 'Отправляйте ссылки\nна папки и файлы — всё появится здесь'
                : 'Создавайте общие папки и отправляйте ссылки\nна файлы — всё появится здесь',
            BottomContent: isB2BUser
                ? undefined
                : () => (
                      <Button
                          mode="secondary"
                          appearance="neutral"
                          size="m"
                          className={styles.button}
                          onClick={(e) => {
                              sendEmptyStatesAnalitics({ action: 'shared-links' });

                              onClickCreateNew(e, { gaSuffix: '', storage: EStorageType.sharedLinks });
                          }}
                      >
                          Создать общую папку
                      </Button>
                  ),
        })
        .set(EStorageType.sharedIncoming, {
            ...icons.sharedIncoming,
            title: 'Пока нет доступных файлов',
            description: (
                <>
                    {sharedIncomingText}
                    {!isB2BUser && (
                        <a
                            data-qa-id="empty-link"
                            href="https://cloud.mail.ru/promo/security/"
                            onClick={() => {
                                sendEmptyStatesAnalitics({ action: 'shared-incoming' });
                            }}
                        >
                            Подробнее о безопасности
                        </a>
                    )}
                </>
            ),
        })
        .set(EStorageType.incomingPublic, {
            ...icons.incomingPublic,
            title: 'Пока нет доступных файлов',
            description: (
                <>
                    {sharedIncomingText}
                    {!isB2BUser && (
                        <a
                            data-qa-id="empty-link"
                            href="https://cloud.mail.ru/promo/security/"
                            onClick={() => {
                                sendEmptyStatesAnalitics({ action: 'shared-incoming' });
                            }}
                        >
                            Подробнее о безопасности
                        </a>
                    )}
                </>
            ),
        })
        .set(
            EStorageType.feed,
            new Map<CategoryType | undefined, Config>()
                .set(undefined, {
                    ...icons.feedAll,
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    title: 'Пока нет файлов',
                    description: 'Когда загрузите, всё будет здесь —\nотсортировано по дате добавления',
                })
                .set(FeedCategoryType.all, {
                    ...icons.feedAll,
                    title: 'Пока нет файлов',
                    description: 'Когда загрузите, всё будет здесь —\nотсортировано по дате добавления',
                })
                .set(FeedCategoryType.image, {
                    ...icons.feedImage,
                    title: 'Пока нет изображений',
                    description: 'Фотографии, картинки, скриншоты — всё будет\nздесь и быстро найдётся по дате добавления',
                })
                .set(FeedCategoryType.document, {
                    ...icons.feedDocument,
                    title: 'Пока нет документов',
                    description: 'Архивы, книги, сканы — загружайте\nи открывайте сразу в PDF, ZIP, EPUB и других\nформатах',
                })
                .set(FeedCategoryType.audio, {
                    ...icons.feedMusic,
                    title: 'Пока нет звуковых файлов',
                    description: isB2BUser
                        ? 'Музыка, подкасты, аудиокниги — загружайте\nи слушайте прямо в Диске'
                        : 'Музыка, подкасты, аудиокниги — загружайте\nи слушайте прямо в Облаке',
                })
                .set(FeedCategoryType.video, {
                    ...icons.feedVideo,
                    title: 'Пока нет видео',
                    description: isB2BUser
                        ? 'Загружайте и смотрите прямо в Диске,\nуправляйте скоростью и качеством картинки'
                        : 'Загружайте и смотрите прямо в Облаке,\nуправляйте скоростью и качеством картинки',
                })
        )
        .set(EStorageType.favorites, {
            ...icons.favorites,
            title: 'Пока нет избранных файлов',
            description: 'Ставьте сердечко на важных и любимых\nфайлах — всё появится здесь',
            BottomContent: () => (
                <Button
                    mode="secondary"
                    appearance="neutral"
                    size="m"
                    className={styles.button}
                    Component="a"
                    href="/home"
                    onClick={() => {
                        sendEmptyStatesAnalitics({ action: 'favorites-click' });
                    }}
                >
                    Ко всем файлам
                </Button>
            ),
        })
        .set(EStorageType.albums, {
            ...icons.album,
            title: 'Пока нет альбомов',
            description: 'Соберите тематическую коллекцию фото или видео — всё будет здесь',
            BottomContent: Albums.BottomContent,
        })
        .set(EStorageType.attaches, {
            ...icons.attaches,
            title: 'Пока нет файлов из Почты',
            description: (
                <>
                    Здесь будут все вложения из писем{'\n'}
                    {!isB2BUser && (
                        <a data-qa-id="empty-link" href={getQuotaPromoUrl({ query: PaymentUTM.emptyAttaches })}>
                            Подробнее
                        </a>
                    )}
                </>
            ),
        })
        .set(EStorageType.trashbin, {
            ...icons.trashbin,
            title: 'В корзине пусто',
            description: 'Здесь файлы хранятся 14 дней, после этого удаляются навсегда',
        })
        .set(EStorageType.sharedAutodelete, {
            icon: SharedAutodeleteIcon,
            title: 'Пока нет автоудаляемых\nпапок',
            iconDark: SharedAutodeleteIconDark,
            description: SharedAutoDelete.Description,
            BottomContent: SharedAutoDelete.BottomContent,
        })
        .set(
            EStorageType.vigbo,
            new Map<CategoryType | undefined, Config>().set(VigboAccountLinkState.unlinked, {
                icon: VigboUnlinked,
                iconDark: VigboUnlinked,
                title: 'Ваши аккаунты Mail и Vigbo пока не связаны',
                description: (
                    <span className={styles.vigboDescription}>Войдите в Vigbo с помощью почты Mail — и можно приступать к работе</span>
                ),
                BottomContent: Vigbo.UnlinkedBottomContent,
            })
        );
};

export const useConfigByStorage = (props: EmptyComponentProps) => {
    const { isMobile, isB2BUser } = props;
    const configByStorage = getConfigByStorage(props);
    const icons = getIcons(props);

    if (isMobile) {
        configByStorage
            .set(EStorageType.gallery, {
                icon: GalleryAllIcon,
                iconDark: GalleryAllIconDark,
                // eslint-disable-next-line sonarjs/no-duplicate-string
                title: 'Галерея ваших фото\nи видео',
                description: 'Загружайте файлы с телефона, чтобы освободить память для новых снимков',
            })
            .set(EStorageType.home, {
                icon: FeedAllIcon,
                iconDark: FeedAllIconDark,
                title: 'Загрузите первый файл',
                description: 'Чтобы быстро находить нужное, пользуйтесь сортировкой и поиском',
            });

        return configByStorage;
    }
    const galleryTitle = 'Пока ничего нет';
    const galleryDescription = isB2BUser ? '' : 'Сохраняйте фото и видео с разных устройств и смотрите истории с лучшими моментами';
    const galleryConfig: Config = {
        ...icons.gallery,
        title: galleryTitle,
        description: galleryDescription,
    };
    const galleryDesktopConfig: Config = {
        icon: GalleryDesktopIcon,
        iconDark: GalleryDesktopIconDark,
        title: 'Пока нет фото и видео',
        description: 'Загрузите файлы — сможете смотреть\nих на любых устройствах',
    };

    const galleryMobileConfig: Config = {
        icon: GalleryMobileIcon,
        iconDark: GalleryMobileIconDark,
        title: <>Пока нет фото и видео</>,
        description: 'Установите Облако на телефон и включите автозагрузку галереи — освободите память для новых кадров',
    };

    const emptySharedFolders: Config = {
        icon: EmptyB2BIcon,
        iconDark: EmptyB2BIconDark,
        title: 'Пока нет общих папок',
        description: '',
    };
    configByStorage
        .set(
            EStorageType.gallery,
            new Map<GalleryCategoryType | undefined, Config>()
                .set(GalleryCategoryType.all, galleryConfig)
                .set(GalleryCategoryType.images, galleryConfig)
                .set(GalleryCategoryType.videos, galleryConfig)
                .set(GalleryCategoryType.desktop, galleryDesktopConfig)
                .set(GalleryCategoryType.mobile, galleryMobileConfig)
        )
        .set(EStorageType.documents, {
            icon: GalleryMobileIcon,
            iconDark: GalleryMobileIconDark,
            title: 'Установите Облако на смартфон',
            description: 'Включите автозагрузку фото и видео, и в смартфоне появится больше свободного места',
        })
        .set(EStorageType.home, emptySharedFolders);

    if (isB2BUser) {
        configByStorage.delete(EStorageType.documents);
    }
    return configByStorage;
};
